// Active Products array
import { createSlice } from "@reduxjs/toolkit";
import { products as initialState } from "../initialState";

export const slice = createSlice({
    name: "products",
    initialState,
    reducers: {
        // There is an api call in UpdateOutdated.js that resets the products if raceCondition
        // is hit
        updateProducts: (state, action) => action.payload,

        // -------------------------------------------------------------------------
        // NOTE: I don't think this is necessary. Currently we are receiving categories
        // that have no products.  We are also receiving products that should only
        // be available on Store Front.  Mike will be adding code to filter these out
        // Therefore how we receive products should not need to get reset.
        // -------------------------------------------------------------------------
        // fetchProducts
    },
});

export const { updateProducts } = slice.actions;

// selectors

// Same as getProducts
export const selectAllProducts = (state) => state.products;

export default slice.reducer;
